import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// components
// sections
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ComboBox from 'src/components/Input/ComboBox';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import Loader from 'src/components/loader/loader';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import { AppConversionRates, AppCurrentVisits } from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function Statistical() {
    const theme = useTheme();
    const [tableData, setTableData] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const getStatisticsRef = useRef(false);
    const refFlags = useRef(false);
    const [IsEmtydata, setIsEmtydata] = useState(true);
    const [dataStatistics, setDataStatistics] = useState([]);
    const [startDay, setstartDay] = useState(moment().format('YYYYMMDD'));
    const monthMoney = useRef({
        now: {},
        prev: {},
        old: {},
    });
    const [department, setDepartment] = useState(null);
    const [departments, setDepartments] = useState([]);
    const departmentRef = useRef();
    const getRef = useRef(false);
    const [dataDateStatistics, setDataDateStatistics] = useState([]);
    // const [startDay, setstartDay] = useState(moment().subtract(1, 'months').format('YYYYMMDD'));

    const { t } = useTranslation();
    const userRef = useRef(null);

    const getSessions = useMemo(() => {
        try {
            userRef.current = JSON.parse(crypt.deCode(sessionStorage.getItem('proc_data')));
        } catch (error) {}
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getDataDepartment();
        }, 1000);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getData(startDay);
        }, 1000);
    }, [startDay, department]);

    const getDataDepartment = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [1];
        sendRequest(serviceList.getAlldepartment, InVal, getDataResultDepartment, true, timeOutFunctDepartment, 40000);
    }, []);

    const getDataResultDepartment = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDepartments(message.proc_data.rows[0].o_1);
            setDepartment(message.proc_data.rows[0].o_1.filter((item) => item.id === userRef.current.department_id)[0]);
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        getRef.current = false;
        toast.error(t('error.time_out'));
    };

    const getData = useCallback(
        (start) => {
            if (refFlags.current) {
                return;
            }
            setGetFlags(true);
            refFlags.current = true;
            const InVal = ['', start, department ? department.id : userRef.current.department_id];
            sendRequest(serviceList.getStatisticsListEtkAndCdr, InVal, getDataResult, true, timeOutFunct, 40000);
        },
        [department]
    );

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        refFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataDateStatistics(message.proc_data.rows[0].o_1);
            setDataStatistics(message.proc_data.rows[0].o_2);
            const data = message.proc_data.rows[0].o_2;
            // console.log("dataStatistics: ", message.proc_data.rows[0])
            //Tổng chi phí/số lượng của 1 phòng ban
            const total_qty_depart = message.proc_data.rows[0].o_3.total_qty_dep;
            const total_price_depart = message.proc_data.rows[0].o_3.total_price_dep;
            console.log(data);
            if (data) {
                const dataUser = data.filter((item) => item.user_id === userRef.current.id);
                if (dataUser?.length > 0) {
                    if (dataUser[0].tong_gia_user || dataUser[0].tong_sl_user) {
                        setIsEmtydata(true);
                    } else {
                        setIsEmtydata(false);
                    }
                    setTableData([
                        {
                            label: dataUser[0].user_nm,
                            price: dataUser[0].tong_gia_user,
                            qty: dataUser[0].tong_sl_user,
                            symbol_currency: dataUser[0].symbol_currency,
                        }, // số lượng và tiền của user
                        {
                            label: `${dataUser[0].departs_nm} ${t('_remaining')}`,
                            qty: total_qty_depart - dataUser[0].tong_sl_user,
                            price: total_price_depart - dataUser[0].tong_gia_user,
                            symbol_currency: dataUser[0].symbol_currency,
                        },
                    ]);
                } else {
                    setTableData([
                        {
                            label: `${data[0].departs_nm} `,
                            qty: total_qty_depart,
                            price: total_price_depart,
                            symbol_currency: dataUser[0].symbol_currency,
                        },
                    ]);
                }
            } else {
                setTableData([]);
                setIsEmtydata(false);
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        refFlags.current = false;
    };
    // const renderHeaederSub = (type = 'money') => {
    //     const currentDateNow = moment(startDay, 'YYYYMMDD').subtract(1, 'months').format('MM/YYYY');
    //     const currentDatePrev = moment(startDay, 'YYYYMMDD').subtract(2, 'months').format('MM/YYYY');
    //     if (
    //         monthMoney.current.now.money &&
    //         monthMoney.current.prev.money &&
    //         monthMoney.current.old.money &&
    //         monthMoney.current.now.qty &&
    //         monthMoney.current.prev.qty &&
    //         monthMoney.current.old.qty
    //     )
    //         try {
    //             if (type === 'money') {
    //                 return `(${monthMoney.current.now.money > monthMoney.current.prev.money ? '' : '+'}${(
    //                     ((monthMoney.current.prev.money - monthMoney.current.now.money) /
    //                         monthMoney.current.now.money) *
    //                     100
    //                 ).toFixed(2)}%) ${t('month')} ${currentDateNow} ${t('and')} (${
    //                     monthMoney.current.now.money > monthMoney.current.old.money ? '' : '+'
    //                 }${(
    //                     ((monthMoney.current.old.money - monthMoney.current.now.money) / monthMoney.current.now.money) *
    //                     100
    //                 ).toFixed(2)}%) ${t('month')} ${currentDatePrev}`;
    //             }
    //             if (type === 'quantity') {
    //                 return `(${monthMoney.current.now.qty > monthMoney.current.prev.qty ? '' : '+'}${(
    //                     ((monthMoney.current.prev.qty - monthMoney.current.now.qty) / monthMoney.current.now.qty) *
    //                     100
    //                 ).toFixed(2)}%) ${t('month')} ${currentDateNow} ${t('and')} (${
    //                     monthMoney.current.now.qty > monthMoney.current.old.qty ? '' : '+'
    //                 }${(
    //                     ((monthMoney.current.old.qty - monthMoney.current.now.qty) / monthMoney.current.now.qty) *
    //                     100
    //                 ).toFixed(2)}%) ${t('month')} ${currentDatePrev}`;
    //             }
    //         } catch (error) {}
    // };

    const renderHeaederSub = () => {
        try {
            const startDate = glb_sv.convertMultipleDate(dataDateStatistics.start_date);
            const endDate = glb_sv.convertMultipleDate(dataDateStatistics.end_date);
            return (
                <>
                    <span>
                        {t('start_day')} {startDate} {t('to_day').toLowerCase()} {endDate}
                    </span>
                    <br />
                    {tableData.length > 0 || dataStatistics.length > 0 ? '' : t('not_data_report')}
                </>
            );
        } catch (error) {}
    };

    return (
        <>
            <Helmet>
                <title> {t('thong_ke')} </title>
            </Helmet>

            <Container maxWidth="xl">
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" sx={{ mb: 2 }}>
                        {t('thong_ke')}
                    </Typography>
                    {/* <Button variant="contained" startIcon={<Iconify icon="ei:share-apple" />} onClick={onDownload}>
                        {t('export_excel')}
                    </Button> */}
                </Stack>{' '}
                <Breadcrumb paths={[{ label: t('thong_ke'), url: '#', navigate: false }]} />
                <Loader loading={getFlags} />
                <Grid container spacing={2}>
                    {/* <Grid item xs={12} sm={12} md={12} xl={12}> */}
                    <Grid item xs={6} sm={6} md={6} xl={6} style={{ width: '100%' }}>
                        <DatePickerValue getValue={setstartDay} label={t('choose_day')} valueChange={startDay} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} xl={6} style={{ width: '100%', paddingTop: '24px' }}>
                        <ComboBox
                            label={t('department')}
                            valueSelect={department}
                            displayLabel="departs_nm"
                            valueEqual="id"
                            sizeCbb="lg"
                            getValue={setDepartment}
                            selectOption={departments}
                            required
                            disabled={userRef.current.department_id}
                        />
                    </Grid>
                    {/* </Grid> */}
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <AppCurrentVisits
                            title={t('statistical_money')}
                            subheader={renderHeaederSub()}
                            chartData={tableData}
                            totalLabel={t('total_money')}
                            value="price"
                            chartColors={[
                                '#0088FE',
                                '#FF8042',
                                '#00C49F',
                                theme.palette.error.main,
                                theme.palette.warning.main,
                                theme.palette.primary.main,
                                theme.palette.info.main,
                                '#FFBB28',
                                '#AF19FF',
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <AppCurrentVisits
                            title={t('statistical_qty')}
                            subheader={renderHeaederSub()}
                            chartData={tableData}
                            totalLabel={t('total_quantity')}
                            value="qty"
                            chartColors={[
                                '#0088FE',
                                '#FF8042',
                                '#00C49F',
                                theme.palette.error.main,
                                theme.palette.warning.main,
                                theme.palette.primary.main,
                                theme.palette.info.main,
                                '#FFBB28',
                                '#AF19FF',
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <AppConversionRates
                            subheader={renderHeaederSub()}
                            title={t('depart_money')}
                            label="user_nm"
                            value="tong_gia_user"
                            chartData={dataStatistics}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <AppConversionRates
                            subheader={renderHeaederSub()}
                            title={t('depart_qty')}
                            label="user_nm"
                            value="tong_sl_user"
                            chartData={dataStatistics}
                        />
                    </Grid>
                </Grid>
                {/* <TableContainer sx={{   }} style={{ display: 'none' }}>
                    <Table ref={tableRef}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('code_department')}</TableCell>
                                <TableCell align="right">{t('name_department')}</TableCell>
                                <TableCell align="right">{t('Khấu hao')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.length > 0 &&
                                tableData.map((item) => {
                                    return (
                                        <TableRow hover key={item.id} tabIndex={-1} role="checkbox">
                                            <TableCell padding="checkbox">{item.depart_cd}</TableCell>

                                            <TableCell align="left" width={200}>
                                                {item.departs_nm}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.sum}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer> */}
            </Container>
        </>
    );
}
